import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLang } from "@/context/LanguageContext";
import { DemoRecipeCard } from "./DemoRecipeCard";
import { slotCategory, slotLabelKey } from "@/lib/demo";

// Choix d'une recette pour un créneau (jour · repas) : uniquement les recettes compatibles de la catégorie
export function DemoSlotPicker({ target, recipes, current, onPick, onView, onClose }) {
  const { t } = useLang();
  const [all, setAll] = useState(false);
  useEffect(() => setAll(false), [target]);
  if (!target) return null;
  const cat = slotCategory(target.slot);
  const pool = recipes.filter((r) => all || r.category === cat);
  const free = pool.filter((r) => r.tier === "free");
  const locked = pool.filter((r) => r.tier !== "free");
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-3xl rounded-3xl chenia-dialog-scroll" data-testid="demo-slot-picker">
        <DialogHeader>
          <DialogTitle className="font-serif text-xl pr-6">{t("dm_pick_for", { day: t(`demo_day_${target.day}`), slot: t(slotLabelKey(target.slot)) })}</DialogTitle>
        </DialogHeader>
        <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
          <span>{t("dm_showing", { count: free.length })}</span>
          <label className="ml-auto inline-flex items-center gap-2"><input type="checkbox" checked={all} onChange={(e) => setAll(e.target.checked)} data-testid="demo-picker-all-cats" />{t("dm_all_cats")} ({t("dm_filter_cat").toLowerCase()})</label>
        </div>
        {free.length === 0 && <p role="alert" className="rounded-xl border border-destructive/30 bg-destructive/5 p-3 text-sm text-destructive">{t("dm_no_recipes_slot")}</p>}
        <div className="grid gap-3 sm:grid-cols-2">
          {[...free, ...locked].map((r) => (
            <DemoRecipeCard key={r.id} recipe={r} picked={current === r.id} locked={r.tier !== "free"} onView={onView} onPick={(rec) => { onPick(target, rec.id); onClose(); }} />
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
